/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AgentExportType } from "../../agentExports/types/AgentExportType";
export const AgentExportJobConfig = core.serialization.object({
    exportType: AgentExportType,
});
